"use client";
import { Alert, Typography } from "@cappelendamm/design-system/react";

import { InfoCircle } from "iconoir-react";
import React from "react";
import classNames from "classnames";
import {
  CHECKOUT_DISABLED_CONTENT,
  CheckoutDisabledReason,
} from "@/checkout/constants";

export type CartDisabledProps = {
  disabledReason: CheckoutDisabledReason;
  className?: string;
};

export function CartDisabled({ disabledReason, className }: CartDisabledProps) {
  const { header, body } = CHECKOUT_DISABLED_CONTENT[disabledReason];
  return (
    <Alert className={classNames("cvr-alert-danger", className)}>
      <InfoCircle width={30} height={30} />
      <div>
        <Typography className="font-semibold">{header}</Typography>
        <Typography className="text-sm">{body}</Typography>
      </div>
    </Alert>
  );
}
